import { db, storage } from './firebase';
import { firestoreKeys } from '../utils/constants';

export default function useActivityService() {
  const createActivity = (userId, data) => db.collection(firestoreKeys.ACTIVITIES).doc(userId).set(data);

  // New: add with auto-ID for 1:many activities
  const addActivity = async (data) => {
    const ref = await db.collection(firestoreKeys.ACTIVITIES).add(data);
    return ref.id;
  };

  const updateActivity = (activityId, data) => db.collection(firestoreKeys.ACTIVITIES).doc(activityId).update(data);

  const addActivityImage = (docId, image) => {
    const ref = storage.ref(`${firestoreKeys.ACTIVITIES}/${docId}/${image.name}`);
    return ref.put(image).then(() => ref.getDownloadURL());
  };

  const deleteActivityImage = (url) => {
    try {
      const ref = storage.refFromURL(url);
      return ref.delete();
    } catch (e) {
      return Promise.resolve();
    }
  };

  const getActivity = (userId) => db.collection(firestoreKeys.ACTIVITIES).doc(userId).get();

  const deleteActivity = async (activityId) =>
    db.collection(firestoreKeys.ACTIVITIES).doc(activityId).delete();

  return { createActivity, addActivity, updateActivity, addActivityImage, deleteActivityImage, getActivity, deleteActivity };
}
